import type { ReactNode } from 'react'
import { useModuleSettings } from '@/api/warehouse'

export function ErstaufnahmeModuleGate({ children }: { children: ReactNode }) {
  const settings = useModuleSettings()
  if (settings.isPending) return <div className="p-4 text-muted">Lade Modul-Einstellungen…</div>
  if (!settings.isError && settings.data?.erstaufnahme_sichtbar === false) {
    return <div className="p-4"><div className="rounded-xl border border-line bg-panel p-4">
      <h1 className="text-xl font-bold">Modul ausgeblendet</h1>
      <p className="mt-2 text-sm text-ink-2">Modul ausgeblendet — einschalten unter Mitarbeiter › Module</p>
    </div></div>
  }
  return children
}
